import React from 'react';
import { useGame } from '../contexts/GameContext';
import { useAuth } from '../contexts/AuthContext';
import { TrophyIcon, UserGroupIcon, ClockIcon, CurrencyDollarIcon } from '@heroicons/react/24/outline';
import toast from 'react-hot-toast';

function Tournaments() {
  const { tournaments, joinTournament } = useGame();
  const { user } = useAuth();

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const handleJoinTournament = async (tournamentId) => {
    const result = await joinTournament(tournamentId);
    if (result.success) {
      toast.success(result.message);
    } else {
      toast.error(result.message);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#f56756] to-[#402e2c] p-6">
      <div className="max-w-4xl mx-auto space-y-6">
        <div className="flex items-center justify-between">
          <h1 className="text-2xl font-bold text-white">Tournaments</h1>
          <div className="flex items-center gap-2 text-[#402e2c]">
            <TrophyIcon className="h-5 w-5" />
            <span>Compete for Big Prizes</span>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-6">
          {tournaments.map((tournament) => (
            <div
              key={tournament.id}
              className="bg-[#b34e42]/80 backdrop-blur-sm rounded-2xl p-6 border border-[#402e2c]/20"
            >
              <div className="flex items-start justify-between">
                <div>
                  <h3 className="text-xl font-semibold text-white mb-2">
                    {tournament.title}
                  </h3>
                  <p className="text-gray-400 mb-4">{tournament.description}</p>
                </div>
                <div
                  className={`px-3 py-1 rounded-full text-sm ${
                    tournament.status === 'active'
                      ? 'bg-green-500/20 text-green-400'
                      : 'bg-blue-500/20 text-blue-400'
                  }`}
                >
                  {tournament.status}
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-6">
                <div className="flex items-center gap-2">
                  <CurrencyDollarIcon className="h-5 w-5 text-[#402e2c]" />
                  <div>
                    <p className="text-sm text-gray-400">Entry Fee</p>
                    <p className="text-white">{tournament.entryFee} coins</p>
                  </div>
                </div>

                <div className="flex items-center gap-2">
                  <TrophyIcon className="h-5 w-5 text-[#402e2c]" />
                  <div>
                    <p className="text-sm text-gray-400">Prize Pool</p>
                    <p className="text-white">{tournament.prizePool} coins</p>
                  </div>
                </div>

                <div className="flex items-center gap-2">
                  <UserGroupIcon className="h-5 w-5 text-[#402e2c]" />
                  <div>
                    <p className="text-sm text-gray-400">Participants</p>
                    <p className="text-white">{tournament.participants.length}</p>
                  </div>
                </div>
              </div>

              <div className="mt-6 flex items-center justify-between">
                <div className="flex items-center gap-2 text-gray-400">
                  <ClockIcon className="h-5 w-5" />
                  <span>
                    Ends {formatDate(tournament.endDate)}
                  </span>
                </div>

                <button
                  onClick={() => handleJoinTournament(tournament.id)}
                  disabled={
                    tournament.participants.includes(user?.id) ||
                    tournament.status !== 'active'
                  }
                  className={`px-4 py-2 rounded-full text-sm font-medium ${
                    tournament.participants.includes(user?.id) ||
                    tournament.status !== 'active'
                      ? 'bg-gray-600 text-gray-400 cursor-not-allowed'
                      : 'bg-[#402e2c] text-white hover:bg-[#402e2c]/80'
                  }`}
                >
                  {tournament.participants.includes(user?.id)
                    ? 'Joined'
                    : tournament.status === 'active'
                    ? 'Join Tournament'
                    : 'Coming Soon'}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Tournaments; 